import * as React from 'react'

export const Spinner = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="25 25 50 50" width="20" height="20" {...props}>
    <circle
      cx="50"
      cy="50"
      r="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 50 50"
        to="360 50 50"
        dur="2s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="stroke-dasharray"
        values="1,150;90,150;1,150"
        dur="1.5s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="stroke-dashoffset"
        values="0;-35;-125"
        dur="1.5s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
)
